import React, { Component } from 'react';
import update from 'react-addons-update'; 

const initialState = {
  options: [
    { key: 0,
      active: false
    },
    {
      key: 1,
      active: false
    },
    {
      key: 2,
      active: false
    },
    {
      key: 3,
      active: false
    },
    {
      key: 4,
      active: false
    },
    {
      key: 5,
      active: false
    },
    {
      key: 6,
      active: false
    },
    {
      key: 7,
      active: false
    },
    {
      key: 8,
      active: false
    },
    {
      key: 9,
      active: false
    },
    {
      key: 10,
      active: false
    }
  ]
};

class RecomendationScale extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }
  click(index, item) {
    this.setState(initialState, () => {
      this.setState({
        options: update(
          this.state.options, 
          {
            [index]: {
              active: {
                $set: true
              }
            }
          }
        )
      }, () => {
        this.props.callbackParent(item.key);
      });
    });

  }
  render() {
    const buttons = this.state.options.map((item, $index) => (
      <li
        className="survey-question-value"
        key={item.key}
        onClick={() => this.click($index, item)}
      >
        <span>{item.key}</span>
        <i className={`survey-question-btn ${item.active ? "active" : ""}`}>
          <i className="survey-question-btn-center" />
        </i>
      </li>
    ));
    return (
      <div className="survey-question">
        <p className="survey-question-text">
        En una escala del 0 al 10 ¿Qué tan probable es que recomiendes Sportium a un amigo o colega?<span>*</span>
        </p>
        <div className="survey-question-satisfaction --flex">
          <div className="survey-question-satisfaction-text--small">
            Poco probable
          </div>
          <ul className="survey-options-list">{buttons}</ul>
          <div className="survey-question-satisfaction-text--small">
            Muy probable
          </div>
        </div>
      </div>
    );
  }
}

export default RecomendationScale;


// WEBPACK FOOTER //
// ./src/components/RecomendationScale.js